import React from "react";
import Modal from "react-modal";
import styled from "styled-components/macro";
import { mdiWindowClose, mdiAlert } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Secondary } from "../Button";

const customStyles: Modal.Styles = {
  content: {
    fontFamily: "sans-serif",
    maxWidth: 500,
    position: "unset",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

const ModalTitle = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const CloseButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  height: 100%;
  padding-top: 5px;
`;

const ModalContent = styled.div`
  margin-bottom: 20px;
`;

const WarningSection = styled.div`
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 5px;
  padding: 15px;
  margin: 15px 0;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const WarningIcon = styled(Icon)`
  color: #856404;
  flex-shrink: 0;
  margin-top: 2px;
`;

const WarningText = styled.div`
  color: #856404;
  font-size: 14px;
  line-height: 1.4;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  warningMessage?: string;
  confirmText?: string;
  cancelText?: string;
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  warningMessage,
  confirmText = "Bestätigen",
  cancelText = "Abbrechen",
}: ConfirmationModalProps): JSX.Element {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles}>
      <ModalTitle>
        <h2>{title}</h2>
        <CloseButton onClick={onClose}>
          <Icon path={mdiWindowClose} size={1} />
        </CloseButton>
      </ModalTitle>

      <ModalContent>
        <div>{message}</div>

        {warningMessage && (
          <WarningSection>
            <WarningIcon path={mdiAlert} size={1} />
            <WarningText>{warningMessage}</WarningText>
          </WarningSection>
        )}
      </ModalContent>

      <ButtonContainer>
        <Button color={Secondary} onClick={onClose}>
          {cancelText}
        </Button>
        <Button onClick={handleConfirm}>{confirmText}</Button>
      </ButtonContainer>
    </Modal>
  );
}
